import { render, staticRenderFns } from "./FourCard.vue?vue&type=template&id=79710650"
import script from "./FourCard.vue?vue&type=script&lang=js"
export * from "./FourCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports